'use client';
export {
  FocusScope,
  FocusScopeBranchProvider,
  useFocusScopeBranchRegistry,
  useFocusScopeBranch,
  //
  Root,
} from './focus-scope';
export type { FocusScopeProps, FocusScopeBranchRegistry } from './focus-scope';
